export default {
  title: "Enter email adress",
  subtitle: "to get your Kegel plan",
  input: {
    placeholder: "Enter your email here"
  },
  submit_button: "Get my plan",
  text_1: "Your personal data is safe with us. We'll use your email for updates, receipts, and subscription details.",
  text_2: "By giving your email address you can also receive offers from Appercut Sp. z o.o. You can unsubscribe at any time.",
  terms: "Terms",
  policy: "Policy"
}
